<template>

</template>

<script>
  export default {
    name: 'logout'
  }
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue